import Collection from "../../../data-structures/collection";
import UserAssignment from "./user-assignment";
import groupAssignmentsByUser from "../actions/group-by-user";
import {ReassignmentDataType} from "../@type";
import TasksCollection from "../../../model2/task/collection";
import EventsCollection from "../../../model2/event/collection";
import ProjectUsersFullCollection from "../../../model2/project-user/collection-full";


export default class UserAssignment_Collection extends Collection<UserAssignment> {

    public taskIds      : ID[]
    public eventIds     : ID[]
    public projectIds   : ID[]

    constructor(models:UserAssignment[]) {
        super(models);

        this.taskIds        = []
        this.eventIds       = []
        this.projectIds     = []
    }

    static initFromJson(data: any, teamUsers: ID[]) {

        const collection = new UserAssignment_Collection([])

        const tasksCollection = TasksCollection.initFromJson(data?.tasks)
        const eventsCollection = EventsCollection.initFromJson(data?.events)
        const projectsCollection = ProjectUsersFullCollection.initFromJson(data?.projects)

        // Group data by user
        const groupedByUser: ReassignmentDataType[] = groupAssignmentsByUser(tasksCollection, eventsCollection, projectsCollection, teamUsers)

        _.map(groupedByUser, (group: ReassignmentDataType)=> {
            const model = new UserAssignment({
                tasks                   : group.taskAssignments,
                events                  : group.eventAssignments,
                projects                : group.projectOwner,

                userId                  : group.assignedToUserId,
                tasksReassignUserId     : null,
                eventsReassignUserId    : null,
                projectReassignUserId   : null,
            })

            collection.add(model)
        })

        collection.taskIds = tasksCollection.ids
        collection.eventIds = eventsCollection.ids
        collection.projectIds = projectsCollection.ids

        return collection
    }

    hasAssignmentsOnlyInOwner(projectOwnerId: ID | null | undefined) {

        return _.every(this.models, (model)=> {
            return model.hasAssignments ? model.userId === projectOwnerId : true
        })

    }

    toJSON(): any {

        return {
            taskIds             : this.taskIds,
            eventIds            : this.eventIds,
            projectIds          : this.projectIds,
            usersReassignments  : _.map(this.models, (model: UserAssignment)=> model.toJSON())
        }

    }

}
